import { AdTargetingStatusResponse } from '@audacy-clients/client-services/src/personalizationServices/types';
import { atom } from 'recoil';

export const adTargetingState = atom<AdTargetingStatusResponse>({
  default: AdTargetingStatusResponse.OPT_IN,
  key: 'adTargetingState',
});
